import React from 'react';
import AdminEnviosDashboard from '../../components/AdminEnviosDashboard';

function EnviosMasivos() {
  return (
    <div>
      <h1>Envíos masivos</h1>
      <AdminEnviosDashboard />
    </div>
  );
}

export default EnviosMasivos;
